export default "__VITE_ASSET__ClyyEgKe__"